import React, { Component } from 'react';
import { BlazeTableColDef, BlazeTableOptions } from 'components/blazeTable/BlazeTable.types';
import BlazeTable from 'components/blazeTable/BlazeTable';
import BlazeExpandButton from 'components/ui/BlazeExpandButton';
import { Request } from 'store/marFiles/marFilesTypes';
import { parseArgumentOperator } from 'utils/assetUtils';
import { WithTranslation, withTranslation } from 'react-i18next';
import i18n from 'i18n';
import NoContentPlaceholder from 'components/ui/noContentPlaceholder/NoContentPlaceholder';

type MarFileAssetViewRequestTabProps = {
  requestData: Request;
};

const colsDefinition: BlazeTableColDef[] = [
  {
    header: i18n.t('marFiles:detailedMeta.tableHeader.name'),
    accessor: 'name',
  },
  {
    header: i18n.t('marFiles:detailedMeta.tableHeader.operator'),
    accessor: 'operator',
  },
  {
    header: i18n.t('marFiles:detailedMeta.tableHeader.value'),
    accessor: 'value',
  },
];

const requestTblOpts: BlazeTableOptions = {
  columnDef: colsDefinition,
  pageable: false,
  selectable: false,
  isRowExpandable: () => false,
  showRowExpander: false,
  tableName: 'requestTable',
  customRowClassName: 'bg-white h-20 flex-table-row',
  customHeaderClassName: 'flex-table-item-top',
  customTableClassName: 'flex-table-simple',
  noResultsText: i18n.t('marFiles:detailedMeta.requestData.noArgumentsAvailable'),
};

class MarFileAssetViewRequestTab extends Component<MarFileAssetViewRequestTabProps & WithTranslation> {
  state = {
    isAreaExpanded: false,
  };

  isAreaExpandedChanged = () => {
    const newVal = !this.state.isAreaExpanded;
    this.setState({
      isAreaExpanded: newVal,
    });
  };

  render() {
    const { requestData } = this.props;
    const { isAreaExpanded } = this.state;
    const cardClassName = isAreaExpanded ? 'expanded-card-area' : '';
    const expandButtonText = isAreaExpanded ? i18n.t('common:actions.showLess') : i18n.t('common:actions.showMore');

    let tableData: any[] = [];

    if (requestData != null && requestData.arguments != null) {
      tableData = requestData.arguments.map((argument, index) => {
        return {
          id: index,
          name: argument.name,
          operator: parseArgumentOperator(argument.type),
          value: argument.value,
        };
      });
    }
    let bodyContent = null;
    if (requestData !== null && requestData.body !== null) {
      if (!requestData.body.binary) {
        bodyContent = Buffer.from(requestData.body.body, 'base64').toString();
      } else {
        bodyContent = i18n.t('marFiles:detailedMeta.requestData.binaryRequestBody');
      }
    }

    return (
      <div className="p-4">
        <div>
          <div className="card-deck mb-4">
            <div className="card">
              <div className="card-header">
                <h2 className="card-title">{i18n.t('marFiles:detailedMeta.requestData.arguments')}</h2>
              </div>
              <div className="card-body">
                <div className={'card-text card-content ' + cardClassName} style={{ overflow: 'auto' }}>
                  <BlazeTable options={requestTblOpts} data={tableData} />
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h2 className="card-title">{i18n.t('marFiles:detailedMeta.requestData.body')}</h2>
              </div>
              <div className="card-body">
                <div className={'card-text card-content ' + cardClassName} style={{ overflow: 'auto' }}>
                  {bodyContent != null && <div className="content-text-area">{bodyContent}</div>}
                  {bodyContent == null && (
                    <NoContentPlaceholder
                      placeHolderContent={i18n.t('marFiles:detailedMeta.requestData.noRequestText')}
                      height={isAreaExpanded ? 560 : 260}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="expand-button-container">
            <BlazeExpandButton
              buttonClass={'btn btn-secondary btn-rounded'}
              buttonText={expandButtonText}
              isTextAreaExpanded={isAreaExpanded}
              fnCallback={this.isAreaExpandedChanged}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation('marFiles')(MarFileAssetViewRequestTab);
